import { formatDateToISO } from './date';

export function addBusinessDays(date, days) {
  const result = new Date(date);
  let added = 0;
  while (added < days) {
    result.setDate(result.getDate() + 1);
    const dayOfWeek = result.getDay();
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      added++;
    }
  }
  return result;
}

/** Midnight local for the given instant (default: now). */
export function startOfLocalDay(date = new Date()) {
  const d = date instanceof Date ? date : new Date(date);
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

/**
 * yyyy-mm-dd da previsão de entrega: dia civil de `createdAtApi` + `businessDays` úteis.
 * `createdAtApi` = string API (ex.: "2026-04-16 14:30:00" ou "2026-04-16").
 */
export function expectedDeliveryISOFromCreatedAt(createdAtApi, businessDays) {
  if (!businessDays || businessDays <= 0 || !createdAtApi) return null;
  const str = String(createdAtApi).trim();
  const ymd = str.slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(ymd)) return null;
  const [y, m, d] = ymd.split('-').map(Number);
  const base = new Date(y, m - 1, d);
  return formatDateISO(addBusinessDays(base, businessDays));
}

export function formatDateISO(date) {
  return formatDateToISO(date);
}

